<div class="col-12 graphics-container">
  <div class="graphics-section">
    <fa-icon icon="user" class="icon blue"></fa-icon>
    <span>
      <strong>{{ totalLeads }}</strong>
      <small>Leads assumidos</small>
    </span>
  </div>

  <div class="graphics-section-divider"></div>

  <div class="graphics-section">
    <fa-icon icon="user" class="icon blue"></fa-icon>
    <span>
      <strong>{{ clientLeads }}</strong>
      <small>Clientes</small>
    </span>
  </div>

  <div class="graphics-section-divider"></div>

  <div class="graphics-section percentage">
    <fa-icon icon="user" class="icon green"></fa-icon>
    <span>
      <strong>{{ conversionRate }}%</strong>
      <small>Leads convertidos</small>
    </span>
  </div>

  <div class="graphics-section-divider"></div>

  <div class="graphics-section">
    <fa-icon icon="check" class="icon green"></fa-icon>
    <span>
      <strong>{{ completedLeads }}</strong>
      <small>Processos finalizados</small>
    </span>
  </div>

  <div class="graphics-section-divider"></div>

  <div class="graphics-section">
    <fa-icon icon="check" class="icon yellow"></fa-icon>
    <span>
      <strong>{{ successfulLeads }}</strong>
      <small>Processos ganhos</small>
    </span>
  </div>

  <div class="graphics-section-divider"></div>

  <div class="graphics-section percentage">
    <span>
      <strong>{{ successfulConversionRate }}%</strong>
      <small>de processos ganhos</small>
    </span>
  </div>
</div>
